import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { AnalysisStrideListItem } from '@sleipai/sleip-models';
import * as fromReview from './review.reducer';

export function selectStrideId(stride: AnalysisStrideListItem) {
  return stride.strideId;
}

export function sortStrideByStride(a: any, b: any) {
  const dateA = a.strideId.toString();
  const dateB = b.strideId.toString();
  return dateA.localeCompare(dateB);
}

export const strideAdapter: EntityAdapter<AnalysisStrideListItem> = createEntityAdapter<AnalysisStrideListItem>({
  selectId: selectStrideId,
  sortComparer: sortStrideByStride,
});

export interface AnalysisStrideState extends EntityState<AnalysisStrideListItem> {}

export const selectStrideState = (state: fromReview.State) => state.strides;
export const { selectAll: selectAllStrides } = strideAdapter.getSelectors();
